var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group-checkbox", class: _vm.containerClass },
    [
      _c("section-error", { attrs: { icon: false } }, [
        _c(
          "div",
          {
            staticClass: "pretty p-icon p-jelly p-smooth p-curve",
            class: { "multi-line": _vm.multiLine, "mr-0": !_vm.label },
          },
          [
            _c("input", {
              staticClass: "checkbox",
              attrs: {
                id: _vm.labelValue,
                name: _vm.name,
                type: "checkbox",
                disabled: _vm.disabled,
                "true-value": _vm.trueValue,
                "false-value": _vm.falseValue,
                tabindex: _vm.tabindex,
              },
              domProps: { checked: _vm.isChecked },
              on: { change: _vm.handleInput },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "state p-success",
                class: { disabled: _vm.disabled },
              },
              [
                _c("i", { staticClass: "icon fa fa-check" }),
                _vm._v(" "),
                _vm.label
                  ? _c(
                      "label",
                      {
                        staticClass: "text-gray",
                        class: { "hidden-text": _vm.hiddenLabel },
                        attrs: { for: _vm.labelValue },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(_vm.label) + "\n        "
                        ),
                      ]
                    )
                  : _c(
                      "label",
                      {
                        staticClass: "text-gray",
                        class: { "hidden-text": _vm.hiddenLabel },
                        attrs: { for: _vm.labelValue },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("global.words.select")) +
                            "\n        "
                        ),
                      ]
                    ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("section-error", { attrs: { "error-message": _vm.errorMessage } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }